import { Injectable } from '@angular/core';
import { GuidedLoginParams, GuidedLoginService, GUIDED_LOGIN_SERVICES } from '@models/guided-login';

const GUIDED_LOGIN_PARAMS_STORAGE_KEY = 'guidedLoginParams';

@Injectable({
  providedIn: 'root'
})
export class GuidedLoginHelperService {

  constructor() { }

  getGuidedLoginParamsForService(serviceId: string, params?: any) {
    const service = this.getGuidedLoginServiceById(serviceId);
    if (!service) {
      return null;
    }
    return {
      serviceId,
      params: this.getGuidedLoginServiceProjectedParams(service, params)
    };
  }

  private getGuidedLoginServiceProjectedParams(service: GuidedLoginService, params: any) {
    if (!service?.paramsProjectionFunction) {
      return null;
    }
    return service.paramsProjectionFunction(params);
  }

  getGuidedLoginServiceById(id: string): GuidedLoginService {
    return (GUIDED_LOGIN_SERVICES || []).find(service => service?.id === id);
  }

  getStoredGuidedLoginParams() {
    try {
      return JSON.parse(this.retrieveGuidedLoginParamsFromStorage()) as GuidedLoginParams;
    } catch (_) {
      return null;
    }
  }

  setGuidedLoginParams(guidedLoginParams: GuidedLoginParams) {
    if (!guidedLoginParams) {
      return;
    }
    try {
      this.saveGuidedLoginParamsToStorage(JSON.stringify(guidedLoginParams));
    } catch (_) {
      return;
    }
  }

  private retrieveGuidedLoginParamsFromStorage() {
    return sessionStorage.getItem(GUIDED_LOGIN_PARAMS_STORAGE_KEY);
  }

  private saveGuidedLoginParamsToStorage(params: string) {
    sessionStorage.setItem(GUIDED_LOGIN_PARAMS_STORAGE_KEY, params);
  }

  removeGuidedLoginParams() {
    try {
      sessionStorage.removeItem(GUIDED_LOGIN_PARAMS_STORAGE_KEY);
    } catch (_) {
      return;
    }
  }
}
